import React from 'react';
import NoAudiencesCreatedDisplay from './NoAudiencesCreatedDisplay';
import Dropdown from 'src/presentation/components/forms/Dropdown';

function AudienceSelector({ audienceOptions, description, section, attr }) {
  if (!audienceOptions.length) {
    return <NoAudiencesCreatedDisplay section={section} />;
  }

  return (
    <Dropdown
      attr={attr}
      data-aid={attr}
      description={description}
      label="Audience"
      placeholder="None"
      options={audienceOptions}
    />
  );
}

export default AudienceSelector;
